module.exports = __webpack_public_path__ + "img/pc-user.d7e63f9c.svg";